function updateNumber(element, newValue) {
    let currentSpan = element.querySelector("span:not(.new)");
    if (currentSpan && parseInt(currentSpan.innerText, 10) === newValue) {
        return;
    }

    const newSpan = document.createElement("span");
    newSpan.classList.add("new");
    newSpan.innerText = newValue.toString().padStart(2, "0");

    if (currentSpan) {
        currentSpan.classList.add("old");
    }

    element.appendChild(newSpan);

    setTimeout(() => {
        element.querySelectorAll("span.old").forEach(span => span.remove());
        newSpan.classList.remove("new");
    }, 500);
}

function initTimer(endTime, sectionID) {
    const SEC = 1000;
    const MIN = SEC * 60;
    const HOUR = MIN * 60;
    const DAY = HOUR * 24;

    const section = document.getElementById(sectionID);
    const timer = section.querySelector('.countdown-timer')
    const endText = section.querySelector('.countdown-end-text')

    const countDown = new Date(endTime).getTime();
    const tick = setInterval(function () {

        const now = new Date().getTime()
        const distance = countDown - now;

        if (distance < 0) {
            timer.classList.add('hidden');
            endText.classList.remove('hidden');
            clearInterval(tick);
            return
        }

        updateNumber(section.querySelector(".countdown-timer-days"), Math.floor(distance / DAY));
        updateNumber(section.querySelector(".countdown-timer-hours"), Math.floor((distance % DAY) / HOUR));
        updateNumber(section.querySelector(".countdown-timer-minutes"), Math.floor((distance % HOUR) / MIN));
        updateNumber(section.querySelector(".countdown-timer-seconds"), Math.floor((distance % MIN) / SEC));

    }, 1000);
}
